import React from 'react';

// import { Container } from './styles';

export const TagInfoWarningIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect id="Frame" width="32" height="32" transform="translate(1631 413)" fill="#e8e8e8" />
        </clipPath>
      </defs>
      <g id="Icon" transform="translate(-1631 -413)" clipPath="url(#clip-path)">
        <g id="Icon-2" data-name="Icon" transform="translate(1631 413)">
          <g id="Path" fill="none" stroke="#d39131" strokeWidth="2.6">
            <circle cx="16" cy="16" r="16" stroke="none" />
            <circle cx="16" cy="16" r="14.7" fill="none" />
          </g>
          <path
            id="Path-2"
            data-name="Path"
            d="M16,9.669v8"
            transform="translate(0 0.492)"
            fill="none"
            stroke="#d39131"
            strokeLinecap="round"
            strokeWidth="2.6"
          />
          <path
            id="Path-3"
            data-name="Path"
            d="M16,22.331h0"
            transform="translate(0 -0.492)"
            fill="none"
            stroke="#d39131"
            strokeLinecap="round"
            strokeWidth="2.6"
          />
        </g>
      </g>
    </svg>
  );
};
